export default __webpack_public_path__ + "static/media/logout.d98839a6.svg";